import { configureStore } from '@reduxjs/toolkit';
import userIpReducer from './slices/userIpSlice';
import userIpDetailsReducer from './slices/userIpDetailsSlice';
import userDataReducer from './slices/userDataSlice';
import apiKeyReducer from './slices/apiKeySlice';

export const store = configureStore({
  reducer: {
    userIp: userIpReducer,
    userIpDetails: userIpDetailsReducer,
    userData: userDataReducer,
    apiKey: apiKeyReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
